<template>
   <div>
     <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="590"
    >
      <v-card>
        <v-card-title class="text-h5">
          Dialogo de confirmação
        </v-card-title>
        <v-card-text>Deseja continuar com a operação ? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="SaveOperacao()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

     <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
         <span v-for="(item, i) in lista" :key="i">
           <p v-if="item.usuario === nomeUsuario" style="font-size:16px;">{{inc+1}}. <span style="font-weight:bold;">{{item.usuario}}</span>  O seu pedido para aceder a  <span style="font-weight:bold;"> {{item.descricao_destino}} </span> está pendente, aguardando a aprovação  <span style="color:red" @click="showDialog(item,-2)">Cancelar</span></p>
           <p v-if="item.usuario !== nomeUsuario" style="font-size:16px;">{{inc+1}}. O usuário <span style="font-weight:bold;">{{item.usuario}}</span> solicita acesso de administrador.  <span style="color:green" @click="showDialog(item,1)">Aprovar</span><span style="color:red;margin-left:10px;" @click="showDialog(item,-1)">Rejeitar</span></p>
        </span>
   </div>
</template>
<script>

const ls = require('local-storage')
import axios from '../plugins/axios'
export default {
  data: ()=>({
    idInstituicao: ls.get('i_id'),
    nomeUsuario: ls.get('nomeUsuario'),
    overlay: false,
    dialog: false,
    operacao:0,
    item: null,
    inc:0
  }),
  props: {
    lista:[]
  },

  methods:{
      
      chamaBotao (id){
        this.$store.dispatch('textMessage', {
          msg: 'Solicitação actualizada com sucesso',
          classMessage: 'msgSucess',
          timeout: 3000
        })
      },

      showDialog(obj,operacao){
        this.operacao = operacao
        this.item = obj
        this.dialog = true
      },

      async SaveOperacao (){

          switch (this.operacao) {
            case 1:
                 this.Aprovar(this.item,1)
              break;
            case -1:
                this.Rejeitar(this.item,-1)
            break;

            case -2:
                this.Cancelar(this.item,-2)
            break;
          
            default:
              break;
          }

      },

    async  Aprovar(item){
      try {
        this.dialog = false
          this.overlay = true
        let params =
        {
          item: item,
          estado: 1,
          autor: ls.get('nomeUsuario')
        }

       let msg = await axios

          .post('/ActualizarSolicitacaoInstituicao', params)
          .then(res => res.data)
         if(msg.affectedRows >= 1){
           console.log(msg);
           setTimeout(() => {
             this.overlay = false
              this.$store.dispatch('textMessage', {
              msg: 'Solicitação aprovada com sucesso',
              classMessage: 'msgSucess',
              timeout: 3000
            })

              const index = this.lista.indexOf(item)
              this.lista.splice(index, 1)
           }, 2000);
         
          
      }
      } catch (error) {
        // this.isLoading = false
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      },
    async  Rejeitar(item){

        try {
          this.dialog = false
          this.overlay = true
        let params =
        {
          item: item,
          estado: -1,
          autor: ls.get('nomeUsuario')
        }

       let msg = await axios

          .post('/ActualizarSolicitacaoInstituicao', params)
          .then(res => res.data)
         if(msg.affectedRows >= 1){
           setTimeout(() => {
              this.overlay = false
              this.$store.dispatch('textMessage', {
              msg: 'Solicitação rejeitada com sucesso',
              classMessage: 'msgSucess',
              timeout: 3000
            })

            const index = this.lista.indexOf(item)
              this.lista.splice(index, 1)
           }, 2000);
         
         
      }
      } catch (error) {
        // this.isLoading = false
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }


      },
    async  Cancelar(item){
          try {
            this.dialog = false
          this.overlay = true
        let params =
        {
          item: item,
          estado: -2,
          autor: ls.get('nomeUsuario')
        }

       let msg = await axios

          .post('/ActualizarSolicitacaoInstituicao', params)
          .then(res => res.data)
         if(msg.affectedRows >= 1){
           setTimeout(() => {
              this.overlay = false
              this.$store.dispatch('textMessage', {
              msg: 'Solicitação cancelada com sucesso',
              classMessage: 'msgSucess',
              timeout: 3000
            })

            const index = this.lista.indexOf(item)
              this.lista.splice(index, 1)
           }, 2000);
         
         
      }
      } catch (error) {
        // this.isLoading = false
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }

      }

  }
 
}
</script>
